<template lang="pug">
v-container.py-8.pl-4
  sharing-qr-code
</template>

<script>
import SharingQrCode from '@/components/review/settings/SharingQrCode.vue'

export default {
  name: 'SharingTab',
  components: {
    SharingQrCode,
  },
}
</script>

<style scoped>
</style>